import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import { ProfileLabelsWidgetOpenSettingsButton } from '../ProfileLabelsWidgetOpenSettingsButton'
import { Widget } from '../Widget'
import { WidgetHeaderContentActionsAddButton } from '../WidgetHeaderContentActionsAddButton'

import { ProfileLabelsWidgetContent } from './ProfileLabelsWidgetContent'

import * as styles from './ProfileLabelsWidget.module.css'

function ProfileLabelsWidget({
  canEdit,
  contentContainerProps: {
    className: contentClassName = styles.content,
    ...restContentContainerProps
  } = EMPTY_OBJECT,
  formProps,
  isSkeleton,
  items = EMPTY_LIST,
  listProps,
  title,
  widgetProps: {
    className = styles.widget,
    headerProps: widgetHeaderProps,
    ...restWidgetProps
  } = EMPTY_OBJECT,
}) {
  const hasLabels = items?.length > 0

  const headerProps = {
    ...widgetHeaderProps,
    contentProps: {
      ...widgetHeaderProps?.contentProps,
      actionsProps: {
        ...widgetHeaderProps?.contentProps?.actionsProps,
        ...(hasLabels ? EMPTY_OBJECT : { ExpandButton: null }),
        AddButton: canEdit ? WidgetHeaderContentActionsAddButton : null,
        AdditionalActions: ProfileLabelsWidgetOpenSettingsButton,
        EditButton: null,
      },
    },
  }

  return (
    <Widget
      {...restWidgetProps}
      className={className}
      contentContainerProps={{
        ...restContentContainerProps,
        className: contentClassName,
      }}
      headerProps={headerProps}
      isSkeleton={isSkeleton}
      title={title}
    >
      <ProfileLabelsWidgetContent
        formProps={formProps}
        items={items}
        listProps={listProps}
      />
    </Widget>
  )
}

export default ProfileLabelsWidget
